import {fabric} from 'fabric';

const toFiniteNumber = (value, fallback = 0) => {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
};

export const getScaledAdditionalLineGeometry = (line = {}) => {
  const scaleX = toFiniteNumber(line.scaleX, 1);
  const scaleY = toFiniteNumber(line.scaleY, 1);
  const dx = (toFiniteNumber(line.x2) - toFiniteNumber(line.x1)) * scaleX;
  const dy = (toFiniteNumber(line.y2) - toFiniteNumber(line.y1)) * scaleY;
  const length = Math.hypot(dx, dy);
  const localAngle = length ? fabric.util.radiansToDegrees(Math.atan2(dy, dx)) : 0;

  return {
    angle: toFiniteNumber(line.angle) + localAngle,
    coords: [0, 0, length, 0],
    length,
    // Additional lines use strokeUniform, so object scaling does not change
    // their rendered stroke width.
    thickness: toFiniteNumber(line.strokeWidth),
    // PSD3 renders an additional line as a degenerate bordered rectangle.
    // Its width includes the border, while `length` is the visible centerline.
    psdWidth: length + toFiniteNumber(line.strokeWidth),
  };
};
